import { useEffect, useRef, useState } from "react"
import { cn } from "@/lib/utils"
import { scrollToSection } from "@/lib/scroll-to-section"
import { ScrambleTextOnHover } from "@/components/scramble-text"

const navItems = [
  { label: "Capability", href: "#work" },
  { label: "Use Cases", href: "#proof" },
  { label: "Team", href: "#credibility" },
  { label: "Why Us", href: "#differentiate" },
]

export function TopNav() {
  const [visible, setVisible] = useState(true)
  const lastScrollY = useRef(0)

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY

      if (currentScrollY <= 0) {
        setVisible(true)
      } else if (currentScrollY > lastScrollY.current + 4) {
        setVisible(false)
      } else if (currentScrollY < lastScrollY.current - 4) {
        setVisible(true)
      }

      lastScrollY.current = currentScrollY
    }

    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <header
      className={cn(
        "fixed inset-x-0 top-0 z-[60] transition-transform duration-300 ease-in-out will-change-transform",
        visible ? "translate-y-0" : "-translate-y-full",
      )}
    >
      <nav
        aria-label="Primary"
        className="relative flex min-h-16 items-center border-b border-white/10 bg-background/30 px-3 py-3 backdrop-blur-xl backdrop-saturate-150 md:px-6 md:py-4"
      >
        <button
          type="button"
          onClick={() => scrollToSection("#hero")}
          className="absolute left-3 flex h-10 w-10 cursor-pointer items-center justify-center transition-opacity duration-200 hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent md:left-6"
          aria-label="Go to AEXIOM home"
        >
          <img
            src="/aexiom-nav-logo.png"
            alt=""
            width="36"
            height="28"
            className="h-6 w-auto object-contain md:h-7"
          />
        </button>

        <div className="ml-14 flex w-full items-center justify-center gap-3 sm:gap-6 md:ml-0 md:gap-6 md:pr-32 lg:gap-16 lg:pr-0">
          {navItems.map((item) => (
          <button
            key={item.label}
            type="button"
            onClick={() => scrollToSection(item.href)}
            className="cursor-pointer font-mono text-[8px] uppercase tracking-[0.14em] text-muted-foreground transition-colors duration-200 hover:text-foreground focus-visible:outline-none focus-visible:text-accent sm:text-[10px] sm:tracking-[0.25em] md:text-xs md:tracking-[0.3em]"
          >
            {item.label}
          </button>
          ))}
        </div>

        <button
          type="button"
          onClick={() => scrollToSection("#close")}
          className="absolute right-3 hidden h-auto w-auto items-center justify-center gap-2 bg-accent px-3 py-2 font-mono text-[10px] uppercase tracking-widest text-background transition-all duration-200 hover:bg-accent/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent md:right-6 md:inline-flex lg:right-[150px] lg:px-4 lg:py-2 lg:text-xs"
          aria-label="Contact us"
        >
          <ScrambleTextOnHover text="Contact Us" as="span" duration={0.6} />
          <svg className="h-4 w-4 transition-transform duration-[400ms] ease-in-out group-hover:rotate-45" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </button>
      </nav>
    </header>
  )
}
